<template>
  <div :class="[hasPadding ? 'p-3 md:p-6' : 'p-0', 'grid grid-cols-12 gap-3']">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ontick-container",
  props: {
    hasPadding: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
